exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 960px) {\n#generateReport {\n    width: 50%;\n    font-size: 55%;\n}\n#listReports #toolbarButton {\n    text-align: center;\n}\n#listReports .datePicker {\n    font: caption;\n}\n#listReports .toolbarFilter {\n    height: 125px;\n}\n#listReports #filterLayout {\n    padding-top: 17%;\n}\n}\n", ""]);

// exports
